import React, { useState } from "react";
import { Box, Button, FormControl, Heading, Input, Text, VStack, useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { VMS_COLORS } from "../constants/theme";
import { vmsApi } from "../services/vmsApi";
import { clearVmsSession, updateVmsUser } from "../utils/auth";

const VmsChangePassword = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentPassword || !newPassword || !confirmPassword) {
      toast({
        title: "Missing fields",
        description: "Please fill all password fields.",
        status: "warning",
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      toast({
        title: "Passwords do not match",
        description: "New password and confirmation must match.",
        status: "warning",
      });
      return;
    }

    setIsLoading(true);
    try {
      const res = await vmsApi.changePassword({
        current_password: currentPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      });
      updateVmsUser({ firstTimeLogin: false, first_time_login: false });
      toast({
        title: "Password changed",
        description: res?.message || "Your password has been updated.",
        status: "success",
      });
      navigate("/vms/requests", { replace: true });
    } catch (err) {
      toast({
        title: "Change password failed",
        description: err?.message || "Unable to change password.",
        status: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSignOut = () => {
    clearVmsSession();
    navigate("/vms/login", { replace: true });
  };

  return (
    <Box minH="100vh" bg={VMS_COLORS.bg} display="grid" placeItems="center" p={4}>
      <Box bg="white" w="100%" maxW="460px" borderRadius="18px" border="1px solid" borderColor="gray.200" p={6}>
        <VStack as="form" align="stretch" spacing={4} onSubmit={handleSubmit}>
          <Heading size="md">Change Password</Heading>
          <Text fontSize="sm" color="gray.600">
            For security, you must change your temporary password before using VMS.
          </Text>
          <FormControl isRequired>
            <Input
              type="password"
              placeholder="Current password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              bg="#F3F4F6"
              borderColor="transparent"
            />
          </FormControl>
          <FormControl isRequired>
            <Input
              type="password"
              placeholder="New password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              bg="#F3F4F6"
              borderColor="transparent"
            />
          </FormControl>
          <FormControl isRequired>
            <Input
              type="password"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              bg="#F3F4F6"
              borderColor="transparent"
            />
          </FormControl>
          <Button type="submit" bg={VMS_COLORS.primary} color="white" isLoading={isLoading}>
            Update password
          </Button>
          <Button type="button" onClick={handleSignOut} variant="ghost" size="sm">
            Sign out
          </Button>
        </VStack>
      </Box>
    </Box>
  );
};

export default VmsChangePassword;
